import { useEffect, useState } from 'react'

import styles from './styles.module.scss'

import { Loader } from '@/components/Loader'

import { useDownload } from '@/pages/@hooks/use-download'
import { useDeleteImage } from '@/pages/@hooks/use-delete-image'
import { useUploadImage } from '@/pages/@hooks/use-upload-image'

import { StorageService } from '@/services/storage'
import { institutionStore } from '@/stores/institution.store'

interface IImage {
  url: string
  id: number
}

const storageService = new StorageService()

export const SeeImages = () => {
  const [image, setImage] = useState<File>()
  const [imagens, setImages] = useState<IImage[]>([])

  const { institution } = institutionStore()

  const { download } = useDownload({ storageService })
  const { uploadImage, isUploading } = useUploadImage({ storageService })
  const { deleteImage, isLoadingDelete } = useDeleteImage({ storageService })

  const addImage = async () => {
    const [response] = await uploadImage(image)
    setImages((state) => [...state, { id: response.id, url: response.url }])
  }

  async function deleteImageCallback(imageId: string) {
    await deleteImage(imageId)
    const new_images = imagens.filter((image) => image.id.toString() != imageId)
    setImages(new_images)
  }

  async function fetchImagens() {
    const images = institution.Images
    const promises = images.map((image) => ({
      links: download(image.filename),
      id: image.id,
    }))
    const _images = await Promise.all(promises.map((p) => p.links))
    setImages(
      _images.map((image, index) => ({
        url: image[0].url,
        id: promises[index].id,
      })),
    )
  }

  useEffect(() => {
    fetchImagens()
  }, [])

  return (
    <div className={styles.image_container}>
      {(isUploading || isLoadingDelete) && <Loader />}
      {imagens.map((imagem) => {
        return (
          <div key={imagem.id} className={styles.image_content}>
            <img width={256} src={imagem.url} />
            <button onClick={() => deleteImageCallback(imagem.id.toString())}>
              DELETAR
            </button>
          </div>
        )
      })}

      {!isUploading && !isLoadingDelete && (
        <div>
          <input onChange={(e) => setImage(e.target.files[0])} type="file" />
          <button disabled={!image} onClick={addImage}>
            Adicionar foto
          </button>
        </div>
      )}
    </div>
  )
}
